import { useRouteSection } from '@/hooks/useRouteSection';
import { useTranslation } from 'react-i18next';

export const InternationalPriceDetails = () => {
  const routeSection = useRouteSection();
  const { t } = useTranslation('translation', {
    keyPrefix: 'priceph',
  });

  return [
    {
      classId: 1,
      classDesc: t('classDesc.silver'),
      mostPopular: false,
      total: {
        upFront: {
          isPercentage: false,
          campaignId: 0,
          discountAmount: 0,
          discountRate: 0,
        },
        basePremium: 42.2,
        netPremium: 31.65,
      },

      coupon: {
        classId: 1,
        code: t('code'),
        emailDomain: t('emailDomain'),
        discountAppliedTo: 0,
        isPercentage: true,
        campaignId: 266,
        discountAmount: 10.55,
        discountRate: 0.25,
      },

      referralInfo: null,
      planHighlight: {
        death: t('death', { amount: '₱ 500,000' }),
        medical: t('medical', { amount: '₱ 500,000' }),
        lossOrDamageBaggage: t('lossOrDamageBaggage', { amount: '₱ 20,000' }),
        baggageDelay: t('baggageDelay', { amount: '₱ 5,000' }),
        travelDelay: t('travelDelay', { amount: '₱ 5,000' }),
        travelCancellation: t('travelCancellation.amount', {
          amount: '₱ 20,000',
        }),
        missedConnection: t('missedConnection.international', {
          amount: '₱ 5,000',
        }),
      },
    },
    {
      classId: 2,
      classDesc: t('classDesc.gold'),
      mostPopular: true,
      total: {
        upFront: {
          isPercentage: false,
          campaignId: 0,
          discountAmount: 0,
          discountRate: 0,
        },
        basePremium: 68.8,
        netPremium: 51.6,
      },

      coupon: {
        classId: 2,
        code: t('code'),
        emailDomain: t('emailDomain'),
        discountAppliedTo: 0,
        isPercentage: true,
        campaignId: 266,
        discountAmount: 17.2,
        discountRate: 0.25,
      },

      referralInfo: null,
      planHighlight: {
        death: t('death', { amount: '₱ 1,000,000' }),
        medical: t('medical', { amount: '₱ 1,000,000' }),
        lossOrDamageBaggage: t('lossOrDamageBaggage', { amount: '₱ 15,000' }),
        baggageDelay: t('baggageDelay', { amount: '₱ 15,000' }),
        travelDelay: t('travelDelay', { amount: '₱ 10,000' }),
        travelCancellation: t('travelCancellation.amount', {
          amount: '₱ 25,000',
        }),
        missedConnection: t('missedConnection.international', {
          amount: '₱ 10,000',
        }),
      },
    },
    {
      classId: 3,
      classDesc: t('classDesc.platinum'),
      mostPopular: false,
      total: {
        upFront: {
          isPercentage: false,
          campaignId: 0,
          discountAmount: 0,
          discountRate: 0,
        },
        basePremium: 91.0,
        netPremium: 68.25,
      },

      coupon: {
        classId: 3,
        code: t('code'),
        emailDomain: t('emailDomain'),
        discountAppliedTo: 0,
        isPercentage: true,
        campaignId: 266,
        discountAmount: 22.75,
        discountRate: 0.25,
      },

      referralInfo: null,
      planHighlight: {
        death: t('death', { amount: '₱ 2,500,000' }),
        medical: t('medical', { amount: '₱ 2,500,000' }),
        lossOrDamageBaggage: t('lossOrDamageBaggage', { amount: '₱ 25,000' }),
        baggageDelay: t('baggageDelay', { amount: '₱ 25,000' }),
        travelDelay: t('travelDelay', { amount: '₱ 15,000' }),
        travelCancellation: t('travelCancellation.amount', {
          amount: '₱ 50,000',
        }),
        missedConnection: t('missedConnection.international', {
          amount: '₱ 15,000',
        }),
      },
    },
  ];
};

export default InternationalPriceDetails;
